/* ------------------------- External Dependencies -------------------------- */
import { Avatar } from 'particles'
export default Avatar



// WEBPACK FOOTER //
// ./src/interface/atomic/molecules/Avatar/index.js